<template>
  <div class="adminaudio">
    <i class="bxr bxs-microphone-alt" @click="showModal = true"></i>
    <ModalBlock v-if="showModal" :loading="loading">
      <div class="close"><i class="bx bx-x clickable" @click="showModal = false"></i></div>
      <div class="container">
        <div class="row pb-2">
          <div class="col-12 text-center black paraugs">{{ text }}</div>
        </div>
        <!-- Record component -->
        <AudioRecord
          class="mb-5"
          :engine="props.engine"
          :entityId="props.id"
          @uploaded="readAudio"
          @error="error = $event"
        />
        <ErrorBlock v-if="error" :error="error" class="mb-3" @close="error = null" />
        <!-- Playback components -->
        <template v-if="curaudio !== undefined">
          <Sortable :list="curaudio" itemKey="id" @end="newOrder">
            <template #item="{ element }">
              <div class="row ieraksts" :data-audio-id="element.id">
                <div class="col-4">
                  <!-- Statuss -->
                  <div class="row mt-1">
                    <FieldStatus
                      class="col-2 text-right mt-1"
                      engine="audio"
                      :id="element.id"
                      v-model="element.status"
                    />
                    <!-- Cilvēks un datums -->
                    <div class="col-10">
                      <div class="row">
                        <div class="col-1 p-0">
                          <i class="bx bx-woman" v-if="element.person_gender === 'female'"></i>
                          <i class="bx bx-man" v-else-if="element.person_gender === 'male'"></i>
                          <i class="icon normal" v-else>0</i>
                        </div>
                        <div class="col-11">
                          <span class="name">{{ element.person_code }}</span
                          ><br />
                          <span class="date">{{ element.datums.substring(0, 10) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-8 mt-1">
                  <div class="row">
                    <AudioWaveform
                      class="col-10"
                      :audioUrl="`${oldUrl}${audioPath}/${element.url}`"
                    />

                    <div class="col-2 mt-1">
                      <IconYesNo @yes="deleteAudio(element.id)" />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </Sortable>
        </template>
      </div>
    </ModalBlock>
  </div>
</template>

<script lang="ts" setup>
import { api } from '@/libs/apiLocal'
import { ref, type Ref, watch } from 'vue'
import ModalBlock from '@/components/common/ModalBlock.vue'
import AudioWaveform from '@/components/common/AudioWaveform.vue'
import AudioRecord from '@/components/common/AudioRecord.vue'
import IconYesNo from '@/components/common/IconYesNo.vue'
import ErrorBlock from '@/components/common/ErrorBlock.vue'
import FieldStatus from '@/components/fields/FieldStatus.vue'
import { Sortable } from 'sortablejs-vue3'
import type { SortableEvent } from 'sortablejs'

const props = defineProps<{
  engine: tAudioEngine
  id: number | string
  text: string
}>()
const oldUrl: string = import.meta.env.VITE_OLD_URL
const audioPath: string = import.meta.env.VITE_AUDIO_PATH || ''
const curaudio: Ref<iAudioInfo[] | undefined> = ref(undefined)
const showModal = ref(false)
const loading = ref(true)
const error: Ref<string | null> = ref(null)

watch(
  showModal,
  (status) => {
    if (status) {
      readAudio()
    } else {
      curaudio.value = undefined
      error.value = null
      loading.value = true
    }
  },
  { immediate: true },
)

// read curent audio file
function readAudio() {
  api
    .get(`/audio/${props.engine}/${props.id}`)
    .then((res) => {
      if (res.data.audio) {
        curaudio.value = res.data.audio
      } else {
        error.value = 'Loading error: Audio not found'
      }
    })
    .catch((err) => {
      error.value = `Loading error: ${err}`
    })
    .finally(() => {
      loading.value = false
    })
}

function deleteAudio(id: number | string) {
  api
    .delete(`/audio/${id}`)
    .then(() => {
      readAudio()
    })
    .catch((err) => {
      error.value = `Error deleting audio: ${err}`
    })
}

function newOrder(event: SortableEvent) {
  if (event.oldIndex !== event.newIndex) {
    // update affected items
    if (event.oldIndex === undefined || event.newIndex === undefined) {
      return
    }
    // izvelkam jauno id kārtību
    const newOrderIds: number[] = Array.from(event.to.children).map((item: Element) =>
      parseInt(item.getAttribute('data-audio-id') || '0'),
    )
    // find affected items
    const start = Math.min(event.oldIndex, event.newIndex)
    const end = Math.max(event.oldIndex, event.newIndex)
    // update saite ids
    for (let i = start; i <= end; i++) {
      api.put(`/audio/${newOrderIds[i]}`, {
        kartiba: i + 1,
      })
    }
  }
}
</script>
